<template>
  <div>
    <section class="ds-job-list-box radius-0 m0 mb10">
        <div class="flex all-t">
          <div class="ds-job-list-info flex-1">
            <p class="pb10">
              <span class="f18 f-b lb-vm pr4">{{recruit.PositionName}}</span>
              <slot name="count"></slot>
            </p>
            <p> <span class="ds-label lb-vm mr5 van-hairline--surround" :class="recruit.PositionType===1?'green':'red'">
              {{recruit.PositionTypeName}}
              </span>
             <span class="f12 c-gray" v-if="!showShare">ID：{{recruit.RecruitSysNo}}</span></p>
             <p class="mt5"><span class="pr4 f14">{{recruit.ShopName}}</span></p>
             <p class="f12 mt5">{{recruit.erName}} | {{recruit.AgeMin}}-{{recruit.AgeMax}}岁 | {{recruit.SexTypeName}}</p>
             <p class="pb10 mt10" v-if="showShare">
        <span class="ds-label van-hairline--surround small" style="border:0 !important" v-for="(welfare, index) in recruit.WelfareList"
              :key="index">{{welfare.TagClassName}}</span>
        </p>
          </div>
          <div class="ds-job-list-extro txt-r">
          <p class="f12 c-gray">{{recruit.LastModifyTime}}</p>
          <p class="c-orange f-b" v-if="recruit.SalaryMin === recruit.SalaryMax">
            {{`${recruit.SalaryMin}${recruit.Reward ? '+' + recruit.Reward : ''}元`}}/{{recruit.SalaryTypeName}}
          </p>
          <p class="c-orange f-b" v-else>
            {{`${recruit.SalaryMin}~${recruit.SalaryMax}${recruit.Reward ?
            '+' + recruit.Reward : ''}元`}}/{{recruit.SalaryTypeName}}
          </p>
          <slot name="commission"></slot>
          <slot name="shareSmallImg"></slot>
        </div>
        </div>
        <p class="pb10 mt10" v-if="!showShare">
        <span class="ds-label van-hairline--surround small" style="border:0 !important" v-for="(welfare, index) in recruit.WelfareList"
              :key="index">{{welfare.TagClassName}}</span>
        </p>
      </section>

      <section class="plr15 bg-white">
      <div class="ds-job-list-footer m0 bd-0">
        <div class="divider">
          <h3 class="fl pr4" v-if="recruit.PositionType===2"><span class="f14 f-b">工作地址与时间</span></h3>
          <h3 class="fl pr4" v-if="recruit.PositionType===1"><span class="f14 f-b">工作地址</span></h3>
          <p class="fr pl4" v-if="showDistance"><span class="f12 c-gray">距离 {{showDistance.Distance}}</span></p>
        </div>
        <div class="flex all-c ds-address">
          <span class="icon icon-address1 f16 c-orange"></span>
          <div class="flex-1 f12" v-if="showShare"><p>{{recruit.ShareContractAddress}}</p></div>
        </div>
        <div class="flex all-t ds-address p0" v-if="recruit.PositionType===2"
             :class="{'mt10':$route.path==='/recruit-detail'}">
            <span class="icon icon-shizhong f16 c-orange"></span>
            <div class="flex-1 f12">
               <div class="f12 lh-2">
                <p>兼职周期：{{recruit.PositionDayArea}}</p>
                <div class="flex all-t">
                  <span>工作日期：</span>
                  <p class="flex-1">
                    <span class="ds-label green green1" v-for="item in recruit.PositionWorkDay.split(' ')"
                    :key="item">{{item}}</span>
                  </p>
                </div>
                <p>工作时段：{{recruit.PositionWorkTimeTypeVaule}} {{recruit.PositionWorkTime}}</p>
              </div>
            </div>
          </div>
      </div>
    </section>
  </div>
</template>

<script>

  export default {
    data() {
      return {};
    },
    props: {
      recruit: {
        type: Object,
        default: () => {
        }
      },
      showDistance: {
        type: Object,
        default: null
      },
      showShare: {
      type: Boolean,
      default: false
      }
    },
    methods: {
    }
  };
</script>
<style lang="less" scoped>
  @import '../../../assets/css/theme.less';

  .divider {
    overflow: hidden;
  }

  .divider > h3, .divider > p {
    background: @white;
    z-index: 2;
    position: relative;
  }

  .ds-job-list-box {
    box-shadow: unset;
  }

  .ds-address {
    line-height: 1.4;
    padding: 10px 0;
  }

  .ds-address .flex-1 {
    padding: 0 8px;
  }
</style>
